import StateView from "@components/StateView/StateView";
import CartModel from "@model/cart/CartModel";
import { message } from "antd";
import { makeAutoObservable } from "mobx";
import { CartService } from "../../../queries/cart/cart.service";
import { VoucherService } from "../../../queries/voucher/voucher.service";

export default class VoucherController {
  list = [];
  filterData = [];
  stateView = StateView.State.loading;
  loading = false;
  sendFilter = {};
  item = {};
  userData = {};
  cartId = "";
  cart = new CartModel();
  stateViewPayment = StateView.State.loading;
  paymentMethod = "cc";
  loadingSide = false;
  loadingCheckout = false;

  paymentKey = "";
  paymentType = "full";
  paymentId = "";
  paymentReference = "";
  router = "";
  payStep = 0;
  redirectUrl = "";
  allData = {};

  constructor() {
    makeAutoObservable(this);
  }

  setPayStep = (step) => {
    this.payStep = step;
  };
  getCart = async (id = "", callback) => {
    this.stateView = StateView.State.loading;
    VoucherService.getCart({ id: id })
      .then(async (res) => {
        callback(res.item);

        this.allData = res.item;
        this.stateView = StateView.State.content;
      })
      .catch((e) => {
        this.stateView = StateView.State.error;
      });
  };
  getData = async () => {
    this.stateView = StateView.State.loading;
    VoucherService.list()
      .then(async (res) => {
        this.list = res;
        // this.setData(res)
        this.stateView = StateView.State.content;
      })
      .catch((e) => {
        this.stateView = StateView.State.error;
      });
  };
  sendVoucherData = async (data, callback) => {
    this.loading = true;
    VoucherService.sendData(data)
      .then(async (res) => {
        this.userData = res.data;
        // this.setData(res)
        callback(res.data);
        this.loading = false;
        this.setPayStep(1);
      })
      .catch((e) => {
        this.loading = false;
      });
  };
  view = async (id, callback) => {
    this.stateView = StateView.State.loading;
    VoucherService.view(id)
      .then(async (res) => {
        this.item = res.item;
        // this.setData(res)
        this.item.text =
          "Redeem your personal gift card at any time using the below code on";
        callback();
        this.stateView = StateView.State.content;
      })
      .catch((e) => {
        this.stateView = StateView.State.error;
      });
  };
  saveFilterData = (item) => {
    this.item = { ...this.item, ...item };
  };

  paymentChange(type, data) {
    this.paymentType = type;
    this.paymentMethod = type;
    switch (type) {
      case "paypal":
        this.getPaymentData({ method: "cc", paymentType: this.paymentType });
        break;
      case "cc":
        this.getSecretPay({ method: "cc", paymentType: this.paymentType });
        break;
      case "sofort":
        this.getSecretSofort({
          method: "sofort",
          paymentType: this.paymentType,
        });
        break;
      case "klarna":
        this.getPaymentData({ ...data, paymentType: this.paymentType });
        break;
    }
  }

  paymentChange2(type, data) {
    this.paymentType = type;
    this.paymentMethod = type;
    switch (type) {
      case "paypal":
        this.getPaymentData({ method: "cc", paymentType: this.paymentType });
        break;
      case "cc":
        this.getPaymentData({ method: "cc", paymentType: this.paymentType });
        break;
      case "sofort":
        this.getPaymentData({
          method: "sofort",
          paymentType: this.paymentType,
        });
        break;
      case "klarna":
        // this.getPaymentData({...data, paymentType: this.paymentType})
        break;
    }
  }

  getSecretPay = (data) => {
    this.paymentKey = "";
    this.paymentReference = "";
    this.stateViewPayment = StateView.State.loading;
    data.payment_type = this.paymentType;
    data.order_id = this.userData.id;

    VoucherService.paymentGet(data, { code: this.cartId })
      .then((res) => {
        this.paymentKey = res.data.payment_clientSecret;
        this.paymentId = res.data.payment_id;
        this.paymentReference = res.reference;

        this.stateViewPayment = StateView.State.content;
      })
      .catch((e) => {
        this.stateViewPayment = StateView.State.error;
      });
  };
  getSecretSofort = (data) => {
    this.paymentKey = "";
    this.paymentReference = "";
    data.payment_type = this.paymentType;
    data.order_id = this.userData.id;

    this.stateViewPayment = StateView.State.loading;
    VoucherService.paymentGet(data, { code: this.cartId })
      .then((res) => {
        this.paymentKey = res.data.payment_clientSecret;
        this.paymentId = res.data.payment_id;
        this.paymentReference = res.reference;
        this.stateViewPayment = StateView.State.content;
      })
      .catch((e) => {
        this.stateViewPayment = StateView.State.error;
      });
  };

  checkPayment = (data = {}) => {
    this.loadingCheckout = true;
    data.reference = this.paymentReference;
    CartService.getPaymentCheck(data, { code: this.cartId })
      .then((res) => {
        this.loadingCheckout = false;
        this.router.push("/user/booking/" + this.cartId);
        // user/booking/ajsdjkahsdjkahsdkjasdjkaskd
      })
      .catch((e) => {
        this.loadingCheckout = false;
      });
  };

  getSecretKlarna = (data) => {
    this.loading = true;
    CartService.getPayKlarna(data, { code: this.cartId })
      .then((res) => {
        this.loading = false;
        if (res.url != null) {
          window.location = res.url;
        }
      })
      .catch((e) => {
        this.loading = false;
      });
  };

  getPaymentData = (data = {}) => {
    this.loading = true;
    data.payment_type = this.paymentType;
    data.order_id = this.userData.id;
    this.stateViewPayment = StateView.State.loading;
    VoucherService.paymentGet(data, {})
      .then((res) => {
        if (res.data.type == "link") {
          this.redirectUrl = res.data.data.url;
        }
        if (res.data.type == "redirect") {
          //
          setTimeout(() => {
            window.location = res.data.data.url;
            message.loading("Redirecting...", 15);
          }, 300);
        }
        this.loading = false;
        this.stateViewPayment = StateView.State.content;
      })
      .catch((e) => {
        this.loading = false;
        this.stateViewPayment = StateView.State.loading;
      });
  };
  //    end paymanet method
}
